module.exports = __webpack_public_path__ + "img/logo.6d3094a5.jpg";